/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserListDataReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserListDataReport model module.
   * @module model/UserListDataReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserListDataReport</code>.
   * @alias module:model/UserListDataReport
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>UserListDataReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserListDataReport} obj Optional instance to populate.
   * @return {module:model/UserListDataReport} The populated <code>UserListDataReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FirstName')) {
        obj['FirstName'] = ApiClient.convertToType(data['FirstName'], 'String');
      }
      if (data.hasOwnProperty('LastName')) {
        obj['LastName'] = ApiClient.convertToType(data['LastName'], 'String');
      }
      if (data.hasOwnProperty('SystemUserTypeName')) {
        obj['SystemUserTypeName'] = ApiClient.convertToType(data['SystemUserTypeName'], 'String');
      }
      if (data.hasOwnProperty('Email')) {
        obj['Email'] = ApiClient.convertToType(data['Email'], 'String');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('MobilePhoneNumber')) {
        obj['MobilePhoneNumber'] = ApiClient.convertToType(data['MobilePhoneNumber'], 'String');
      }
      if (data.hasOwnProperty('ImmediateSuperior')) {
        obj['ImmediateSuperior'] = ApiClient.convertToType(data['ImmediateSuperior'], 'String');
      }
      if (data.hasOwnProperty('LastLoginDate')) {
        obj['LastLoginDate'] = ApiClient.convertToType(data['LastLoginDate'], 'Date');
      }
      if (data.hasOwnProperty('IsEmailEditable')) {
        obj['IsEmailEditable'] = ApiClient.convertToType(data['IsEmailEditable'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} FirstName
   * @default ''
   */
  exports.prototype['FirstName'] = '';
  /**
   * @member {String} LastName
   * @default ''
   */
  exports.prototype['LastName'] = '';
  /**
   * @member {String} SystemUserTypeName
   * @default ''
   */
  exports.prototype['SystemUserTypeName'] = '';
  /**
   * @member {String} Email
   * @default ''
   */
  exports.prototype['Email'] = '';
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {String} MobilePhoneNumber
   * @default ''
   */
  exports.prototype['MobilePhoneNumber'] = '';
  /**
   * @member {String} ImmediateSuperior
   * @default ''
   */
  exports.prototype['ImmediateSuperior'] = '';
  /**
   * @member {Date} LastLoginDate
   */
  exports.prototype['LastLoginDate'] = undefined;
  /**
   * @member {Boolean} IsEmailEditable
   * @default false
   */
  exports.prototype['IsEmailEditable'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


